import type { FunctionComponent, ReactNode } from 'react';

import { Checkbox } from '@dr.pogodin/react-utils';

import { VIDEO_INTENTS, type VideoIntentT } from 'utils';

import radioCheckboxTheme from 'themes/Checkbox/cms/radio.scss';

import './style.scss';

type PropsT = {
  intents: VideoIntentT[];
  label?: string;
  onChange: (intents: VideoIntentT[]) => void;

  /**
   * This flag renders checkboxes as radio (circles), and allows to only
   * select one option a time.
   */
  singleSelect?: boolean;
};

// TODO: This should be reworked, to make only one intent selectable?
export const VideoIntents: FunctionComponent<PropsT> = ({
  intents,
  label,
  onChange,
  singleSelect,
}) => {
  const nodes: ReactNode[] = [];
  const set = new Set(intents);

  for (const intent of VIDEO_INTENTS) {
    const checked = set.has(intent);
    nodes.push(
      <Checkbox
        checked={checked}
        key={intent}
        label={intent}
        onChange={() => {
          if (singleSelect) {
            onChange([intent]);
          } else {
            onChange(
              checked
                ? intents.filter((item) => item !== intent)
                : [...intents, intent],
            );
          }
        }}
        theme={singleSelect ? radioCheckboxTheme : undefined}
      />,
    );
  }

  return (
    <div styleName="checkboxGroup">
      <div styleName="checkboxGroupTitle">
        {label ?? (singleSelect ? 'Video Intent' : 'Video Intents')}
      </div>
      {nodes}
    </div>
  );
};
